export default __webpack_public_path__ + "static/media/logo2.089c8562.jpg";